import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=13580cfd"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"
import style0 from "./additional.vue?vue&type=style&index=0&id=13580cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports